
console.log('All env vars:', process.env);

const config = {
    AppEnv: process.env.REACT_APP_APP_ENV,
    BaseUrl: process.env.REACT_APP_BASE_URL,

    FacebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,
    GISClientId: process.env.REACT_APP_GIS_CLIENT_ID,
    StripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,

    // These are for frontend drowdrop list
    CLIENT_VIEW_TEXT : "Customer",
    WORKER_VIEW_TEXT : "Service Provider",

    // These are for backend db
    CLIENT_VIEW_ID : "Client",
    WORKER_VIEW_ID : "Worker",
};

console.log("React app starting with config:", config);
  
export default config;
